export const REST_FUNDING_COLORS = [
  '#b5b5b5',
  '#949494',
]
